import React, { useState } from "react";
import { FaCheck, FaDiscord, FaInfoCircle, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import { CDN_BASE_URL } from "../../config";
import { FaMedium } from "react-icons/fa6";
import MediumModal from "../common/modals/MediumModal";

const ArticaleTask = ({ user, getData, reward }) => {
  const [showMedium, setshowMedium] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div
      className={`${
        user?.medium === "progress" && "order-last opacity-40"
      } flex justify-between gap-3 items-center relative py-2 pb-4 border-b`}
    >
      {showMedium && (
        <>
          <div
            onClick={() => setshowMedium(false)}
            className="w-full h-full z-40 bg-black/50 fixed top-0 left-0"
          ></div>
          <MediumModal setShow={setshowMedium} getData={getData} />
        </>
      )}

      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">
          <div className="bg-[#1e293b] rounded-xl max-w-[90%] w-full sm:w-[600px] p-4">
            <div className="flex justify-between items-center mb-4 text-white">
              <button
                onClick={() => setIsModalOpen(false)}
                className="text-lg font-bold"
              >
                <FaTimes />
              </button>
            </div>
            <h2 className="text-xl font-bold text-center">
              The article you publish must be on Medium.
            </h2>
          </div>
        </div>
      )}
      <span className="flex items-center gap-2 lg:gap-4">
        <FaMedium className="text-[32px] sm:text-[54px] lg:text-[72px]" />
        <span>
          <h4 className="font-bold text-[14px] lg:text-[28px] lg:-mb-2 flex gap-2 items-center">
            Write an Article
            <FaInfoCircle
              className="text-blue-400 cursor-pointer"
              onClick={() => setIsModalOpen(true)}
              title="Help"
            />
          </h4>
          <span className="font-bold text-[16px] lg:text-[28px] flex gap-1 items-center">
            <img src="/gold.png" className="w-6 lg:w-8" alt="GOLD" />+{reward}
          </span>
        </span>
      </span>
      {user?.medium ? (
        <>
          <span className="flex flex-col items-center justify-center">
            <button
              disabled={user?.medium === "progress"}
              onClick={() => setshowMedium(true)}
              className="start-button px-4 lg:px-8 py-2 bg-[#02006A] shadow shadow-white/40 rounded-full text-[14px] lg:text-[24px] flex gap-2 items-center"
            >
              {user?.medium === "progress" ? <>in Progress...</> : <>Start</>}
            </button>
            {user?.medium === "checked" ? (
              <span className="text-green-500 text-[14px] text-center">
                last one is approved
              </span>
            ) : user?.medium === "rejected" ? (
              <span className="text-red-500 text-[14px] text-center">
                last one is rejected
              </span>
            ) : null}
          </span>
        </>
      ) : (
        <span className="flex flex-wrap gap-2 justify-end">
          <button
            onClick={() => setshowMedium(true)}
            className="start-button px-4 lg:px-8 py-2 bg-[#02006A] shadow shadow-white/40 rounded-full text-[14px] lg:text-[24px] flex gap-2 items-center"
          >
            Start
          </button>
        </span>
      )}
    </div>
  );
};

export default ArticaleTask;
